module.exports = __webpack_public_path__ + "static/data-621339a5e502c8d5f7b7c80568cb2b12.webp";